"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _badgeCollinsonmodulecss = /*#__PURE__*/ _interop_require_default(require("../../../../dist/assets/components/badgeCollinson.module.css"));
var _clsx = /*#__PURE__*/ _interop_require_default(require("clsx"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var HeaderNavBadge = function(param) {
    var inverted = param.inverted, size = param.size, variant = param.variant;
    var _obj, _obj1, _obj2;
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
        className: (0, _clsx.default)([
            _badgeCollinsonmodulecss.default.badgeCollinson,
            (_obj = {}, _obj[_badgeCollinsonmodulecss.default.badgeInverted] = inverted, _obj),
            (_obj1 = {}, _obj1[_badgeCollinsonmodulecss.default.badgeSmall] = size === "small", _obj1),
            (_obj2 = {}, _obj2[_badgeCollinsonmodulecss.default.badgeNavy] = variant === "partner", _obj2)
        ]),
        children: "Collinson"
    });
};
var _default = HeaderNavBadge;
